import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { NgClass } from "@angular/common";

@Component({
    selector: "rask-busy-tree",
    templateUrl: "./busy-tree.component.html",
    styleUrls: ["./busy-tree.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})
export class BusyTreeComponent {
    @Input() size: BusyTreeSize = "2";
    @Input() type: BusyTreeType = "auto";

    get classes(): string {
        return `${this.sizeClass} type-${this.typeClass}`;
    }
    private get sizeClass(): string {
        return `size-${this.size}x`;
    }

    private get typeClass(): string {
        if (this.type === "auto") {
            if((new Date()).getMonth() === 11) {
                return "julgran";
            }else{
                return "normal";
            }
        }

        return this.type;
    }
}

type BusyTreeSize = "1" | "2" | "3" | "4" | "5";
type BusyTreeType = "normal" | "julgran" | "auto";
